module.exports = __webpack_public_path__ + "img/Paladin-draenei-f-70.45f5446d.gif";